module.exports = __webpack_public_path__ + "media/images/sports_icons/gymnastics-b7bd0ee3f3cbdc6a15050cb881d9abde.png";